module.exports = __webpack_public_path__ + "img/arrow.e86a6da3.png";